'use client';
import styled from 'styled-components';

export const StyledPupInfoFormContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;
